import React from "react";
import { bool } from "prop-types";

import HeaderNavLink from "../../HeaderNavLink";

const OwnerTools = ({ ravens_fxbo_owner_tools }) => (
  <HeaderNavLink
    href={
      ravens_fxbo_owner_tools ? "/manage/owner-tools?site=nyc" : "/nyc/manage"
    }
  >
    Owner Tools
  </HeaderNavLink>
);

OwnerTools.propTypes = { ravens_fxbo_owner_tools: bool.isRequired };

export default OwnerTools;
